import * as React from "react";
import { Typography, Card, CardContent } from "@mui/material";
import "./lotterySystem.css";
import { useTranslation } from 'react-i18next';

const LotteryDisplay: React.FC = () => {
  const { t } = useTranslation('translation');

  return (
    <>
      <Typography id="lottery-display" className="landing-section-heading landing-secondary-color landing-headers-orange-color" variant="h6" align="center">{t("lotteryDisplay")}</Typography>
      {Array(4).fill("").map((element: string, index: number) =>
        index % 2 === 0 ?
          <Card key={index} className="card-even landing-card" variant="outlined">
            <CardContent>
              <Typography className="landing-card-content-typo landing-text-white">
                {t(`lotteryDisplayContent${index + 1}`)}
              </Typography>
            </CardContent>
          </Card> :
          <Card key={index} className="card-odd landing-card" variant="outlined">
            <CardContent>
              <Typography id={`features${index + 1}`}className="landing-card-content-typo landing-text-white">
                {t(`lotteryDisplayContent${index + 1}`)}
              </Typography>
            </CardContent>
          </Card>
      )}
    </>
  )
}

export default LotteryDisplay;